<script>
/**
 * 新闻卡片（自 vancheen-b2b 的 NewsCard.vue 移植为 Vue 2 版本）
 * item.more 站内链接用 NhLink 渲染。
 */
import NhLink from './NhLink.vue'
import NhSvgIcon from './NhSvgIcon.vue'
import asset from '../nh-asset'

export default {
  name: 'NhNewsCard',
  components: { NhLink, NhSvgIcon },
  props: {
    item: { type: Object, required: true },
    delay: { type: [Number, String], default: undefined }
  },
  methods: {
    asset
  }
}
</script>

<template>
  <article v-reveal="delay" class="news-card">
    <div class="nc-img">
      <el-image :src="asset(item.img)" :alt="item.alt" fit="cover" lazy>
        <template #error>
          <div class="nc-img-fallback">{{ item.title }}</div>
        </template>
      </el-image>
    </div>
    <div class="nc-body">
      <div class="nc-date">
        <NhSvgIcon name="clock" />{{ item.date }}
      </div>
      <h3>{{ item.title }}</h3>
      <p>{{ item.desc }}</p>
      <NhLink v-if="item.more" class="nc-more" :to="item.more.to">
        {{ item.more.label }}
        <NhSvgIcon class="mini-ic" name="arrow" />
      </NhLink>
    </div>
  </article>
</template>

<style scoped>
.nc-img-fallback {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 12px;
  font-size: 12px;
  color: #9ca3af;
  text-align: center;
}
</style>
